import React from 'react';
import { modelClass } from '/imports/api/logActivities';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const LogActivitiesPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'timestamp', label: 'Timestamp' }, { field: 'bot', label: 'Bot' }, { field: 'level', label: 'Level' }, { field: 'entry', label: 'Entry' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
